import { MapPin } from "lucide-react";
import { JEREMY } from "@/lib/jeremy";

// Rough coordinates for stylized VA map (0-100 viewbox)
const AREAS = [
  { name: "Fredericksburg", cx: 62, cy: 44 },
  { name: "Stafford County", cx: 63, cy: 40 },
  { name: "Spotsylvania County", cx: 58, cy: 46 },
  { name: "King George County", cx: 68, cy: 42 },
  { name: "Caroline County", cx: 60, cy: 51 },
  { name: "Orange County", cx: 52, cy: 48 },
  { name: "Culpeper County", cx: 50, cy: 40 },
  { name: "Prince William County", cx: 65, cy: 34 },
  { name: "Northern Virginia", cx: 68, cy: 30 },
  { name: "Richmond-area", cx: 58, cy: 62 },
];

export default function ServiceArea() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F4EB]" data-testid="service-area-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <div className="eyebrow">Local Virginia Presence</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold text-[#0F382C]">
            Solar guidance from someone who understands Virginia.
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            Virginia utilities, Virginia homes, and the questions local homeowners are actually asking — I meet homeowners where they live, from Fredericksburg to Northern Virginia and the Richmond corridor.
          </p>

          <ul className="mt-8 grid grid-cols-2 gap-2" data-testid="service-area-list">
            {JEREMY.serviceAreas.map((s) => (
              <li key={s} className="flex items-center gap-2 text-sm text-[#0F382C]">
                <span className="w-1.5 h-1.5 rounded-full bg-[#D97706]" /> {s}
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-slate-500">These are areas Jeremy is available for home consultations. Jeremy can still help anyone in the state of Virginia.</p>
        </div>

        <div className="lg:col-span-6">
          <div className="rounded-3xl bg-[#0B261E] p-6 md:p-8 border border-white/10">
            <div className="flex items-center justify-between mb-4">
              <div className="font-serif-display text-xl text-[#F8FAFC]">Virginia Service Map</div>
              <div className="badge-pill" style={{ background: "rgba(217,119,6,0.2)", color: "#FEF3C7", border: "1px solid rgba(217,119,6,0.3)" }}>
                <MapPin className="w-3.5 h-3.5" /> Illustrative
              </div>
            </div>
            <svg viewBox="0 0 100 100" className="w-full h-auto" role="img" aria-label="Illustrative map of Jeremy's Virginia service areas">
              <path
                d="M 8 30 L 30 22 L 50 20 L 72 24 L 88 32 L 92 42 L 88 55 L 78 68 L 66 78 L 52 82 L 40 78 L 28 70 L 18 58 L 10 46 Z"
                fill="rgba(15,56,44,0.75)"
                stroke="rgba(254,243,199,0.2)"
                strokeWidth="0.4"
              />
              {AREAS.map((a) => (
                <g key={a.name}>
                  <circle cx={a.cx} cy={a.cy} r="3" fill="#D97706" opacity="0.3">
                    <animate attributeName="r" values="3;5;3" dur="3s" repeatCount="indefinite" />
                    <animate attributeName="opacity" values="0.4;0.1;0.4" dur="3s" repeatCount="indefinite" />
                  </circle>
                  <circle cx={a.cx} cy={a.cy} r="1.2" fill="#FEF3C7" />
                </g>
              ))}
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}
